import React, { useState } from 'react';
import { Modal, Form, Row, Col, Table, Tabs, Tab, Spinner, Card, Button } from 'react-bootstrap';
import { useQuery } from 'react-query';
import * as moment from 'moment';
import { Get, Put } from '../../../../../utils/httpProvider';
import { toast } from 'react-toastify';
import { 
    HOSO_TUYENSINH_API, 
    LYLICHKHOAHOC_API, 
    MINHCHUNGKHOAHOC_API, 
    DECUONGNGHIENCUU_API, 
    VANBANGTUYENSINH_API, 
    VANBANGCHUNGCHINGOAINGU_API,
    VANBANGDAIHOC_API,
    NGANH_API,
    CHUYENNGANH_API,
    CHITIETKETQUANCS_API,
    TRINHDO_API,
    DONVIDAOTAO_API,
    QUOCGIA_API,
    HINHTHUCDAOTAO_API,
    XEPLOAIDAOTAO_API,
    BaseGatewayImage,
    DUYET_HOSO_TUYENSINH_API,
    ACCOUNT_API,
    LOPDAOTAOLIENTUC_API,
    LOPDAOTAOTHUCHANH_API
} from '../../../../../utils/apiUrl';
import { objectGioiTinhHoSo, gioiTinhHoSo as gioiTinhHoSoValue, objectAccountGender, objectObjectAccount, objectLoaiVanBang, objectCapQuanLy, objectLoaiCanBoHuongDan, doiTuongValue, loaiVanBangValue, capQuanLyValue, loaiCanBoHuongDanValue, gioiTinh as gioiTinhValue, objectTrinhDoDaoTaoTSTS, trinhDoDaoTaoTSTSValue, objectLoaiTuyenSinh, loaiTuyenSinhValue } from '../../../../../utils/define';
import { useEffect } from 'react';
import DanhGiaThiSinhForm from '../../tuyenSinhTienSi/chiTietKetQuaNCS/DanhGiaThiSinhForm';
import DanhGiaHoSoTuyenSinhTienSiForm from '../../tuyenSinhTienSi/chiTietKetQuaNCS/DanhGiaHoSoTuyenSinhTienSiForm';
import KetQuaTuyenSinhTab from './KetQuaTuyenSinhTab';

const DuyetHoSoTuyenSinhDetailModal = ({ show, handleClose, hoSoId }) => {

    const [ghiChuChinhSua, setGhiChuChinhSua] = useState('');
    const [submitting, setSubmitting] = useState(false);
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [actionType, setActionType] = useState(null);

    // APIs Data
    const { data: hoSo, isLoading: load1, refetch: refetchHoSo } = useQuery(['hoSoTuyenSinhDetail', hoSoId], () => Get(HOSO_TUYENSINH_API.GET_ITEM, hoSoId), { enabled: !!hoSoId });
    const { data: lyLichRes, isLoading: load2 } = useQuery(['lyLich', hoSoId], () => Get(LYLICHKHOAHOC_API.GET_BY_HOSO_ID, null, { hoSoTuyenSinhId: hoSoId }), { enabled: !!hoSoId });
    const { data: minhChungRes, isLoading: load3 } = useQuery(['minhChung', hoSoId], () => Get(MINHCHUNGKHOAHOC_API.GET_BY_HOSO_ID, null, { hoSoTuyenSinhId: hoSoId }), { enabled: !!hoSoId });
    const { data: deCuongRes, isLoading: load4 } = useQuery(['deCuong', hoSoId], () => Get(DECUONGNGHIENCUU_API.GET_BY_HOSO_ID, null, { hoSoTuyenSinhId: hoSoId }), { enabled: !!hoSoId });
    const { data: vanBangRes, isLoading: load5 } = useQuery(['vanBang', hoSoId], () => Get(VANBANGTUYENSINH_API.GET_BY_HOSO_ID, hoSoId), { enabled: !!hoSoId });
    const { data: vbNgoaiNguRes, isLoading: load6 } = useQuery(['vbNgoaiNgu', hoSoId], () => Get(VANBANGCHUNGCHINGOAINGU_API.GET_BY_HOSO_ID, hoSoId), { enabled: !!hoSoId });
    const { data: vanBangDaiHocRes, isLoading: loadVanBangDaiHoc } = useQuery(['vanBangDaiHoc', hoSoId], () => Get(VANBANGDAIHOC_API.GET_BY_HOSO_ID, hoSoId), { enabled: !!hoSoId });
    
    const { data: ketQuaRes, isLoading: load7 } = useQuery(
        ['ketQuaNCS', deCuongRes?.data?.id || deCuongRes?.data?.Id], 
        () => Get(CHITIETKETQUANCS_API.GET_PAGING, null, { pageIndex: 1, pageSize: 1000, DeCuongNghienCuuId: deCuongRes?.data?.id || deCuongRes?.data?.Id }),
        { enabled: !!(deCuongRes?.data?.id || deCuongRes?.data?.Id) }
    );

    const loaiTuyenSinhRaw = hoSo?.loaiTuyenSinh ?? hoSo?.LoaiTuyenSinh;
    let actualLoaiTuyenSinh = loaiTuyenSinhRaw;
    if (typeof loaiTuyenSinhRaw === 'string') {
        actualLoaiTuyenSinh = loaiTuyenSinhValue[loaiTuyenSinhRaw] ?? loaiTuyenSinhValue[loaiTuyenSinhRaw.charAt(0).toLowerCase() + loaiTuyenSinhRaw.slice(1)];
    }

    const { data: khoahocData } = useQuery(['khoahocDetail', hoSo?.dotTuyenSinhId, actualLoaiTuyenSinh], () => {
        if (actualLoaiTuyenSinh === 1) return Get(LOPDAOTAOLIENTUC_API.GET_ITEM, hoSo?.dotTuyenSinhId);
        if (actualLoaiTuyenSinh === 2) return Get(LOPDAOTAOTHUCHANH_API.GET_ITEM, hoSo?.dotTuyenSinhId);
        return null;
    }, { enabled: !!hoSo?.dotTuyenSinhId && (actualLoaiTuyenSinh === 1 || actualLoaiTuyenSinh === 2) });

    // Dictionaries
    const { data: nganhRes } = useQuery(['nganhData'], () => Get(NGANH_API.GET_PAGING + '?pageSize=1000'), { enabled: show });
    const nganhOptions = (nganhRes?.data?.$values || nganhRes?.data || []).map(item => ({ value: item.id, label: item.tenNganh }));

    const { data: chuyenNganhRes } = useQuery(['chuyenNganhData'], () => Get(CHUYENNGANH_API.GET_PAGING + '?pageSize=1000'), { enabled: show });
    const chuyenNganhOptions = (chuyenNganhRes?.data?.$values || chuyenNganhRes?.data || []).map(item => ({ value: item.id, label: item.tenChuyenNganh, nganhId: item.nganhId }));

    const { data: trinhDoRes } = useQuery(['trinhDoData'], () => Get(TRINHDO_API.GET_ALL_PAGING + '?pageSize=1000'), { enabled: show });
    const trinhDoOptions = (trinhDoRes?.data?.$values || trinhDoRes?.data || []).map(item => ({ value: item.id, label: item.tenTrinhDo }));

    const { data: donViDaoTaoRes } = useQuery(['donViDaoTaoData'], () => Get(DONVIDAOTAO_API.GET_ALL_PAGING + '?pageSize=1000'), { enabled: show });
    const donViDaoTaoOptions = (donViDaoTaoRes?.data?.$values || donViDaoTaoRes?.data || []).map(item => ({ value: item.id, label: item.tenDonViDaoTao }));

    const { data: quocGiaRes } = useQuery(['quocGiaData'], () => Get(QUOCGIA_API.GET_ALL_PAGING + '?pageSize=1000'), { enabled: show });
    const quocGiaOptions = (quocGiaRes?.data?.$values || quocGiaRes?.data || []).map(item => ({ value: item.id, label: item.tenQuocGia }));

    const { data: hinhThucDaoTaoRes } = useQuery(['hinhThucDaoTaoData'], () => Get(HINHTHUCDAOTAO_API.GET_ALL_PAGING + '?pageSize=1000'), { enabled: show });
    const hinhThucDaoTaoOptions = (hinhThucDaoTaoRes?.data?.$values || hinhThucDaoTaoRes?.data || []).map(item => ({ value: item.id, label: item.tenHinhThuc }));

    const { data: xepLoaiDaoTaoRes } = useQuery(['xepLoaiDaoTaoData'], () => Get(XEPLOAIDAOTAO_API.GET_ALL_PAGING + '?pageSize=1000'), { enabled: show });
    const xepLoaiDaoTaoOptions = (xepLoaiDaoTaoRes?.data?.$values || xepLoaiDaoTaoRes?.data || []).map(item => ({ value: item.id, label: item.tenXepLoai }));

    const isLoading = load1 || load2 || load3 || load4 || load5 || load6 || load7 || loadVanBangDaiHoc;

    const dataHoSo = hoSo || {};
    const dataLyLich = lyLichRes?.data || {};
    const dataMinhChung = minhChungRes?.data || {};
    const dataDeCuong = deCuongRes?.data || {};
    
    // Arrays
    const baiBaoKhoaHocs = dataLyLich.baiBaoKhoaHocs?.$values || dataLyLich.baiBaoKhoaHocs || [];
    const deTaiNCKHs = dataMinhChung.deTaiNCKHs?.$values || dataMinhChung.deTaiNCKHs || [];
    const canBoHuongDans = dataDeCuong.canBoHuongDans?.$values || dataDeCuong.canBoHuongDans || [];
    const vanBangTuyenSinhs = vanBangRes?.data?.$values || vanBangRes?.data || [];
    const vanBangNgoaiNgus = vbNgoaiNguRes?.data?.$values || vbNgoaiNguRes?.data || [];
    const vanBangDaiHocs = vanBangDaiHocRes?.data?.$values || vanBangDaiHocRes?.data || [];

    let listKetQua = [];
    if (Array.isArray(ketQuaRes)) listKetQua = ketQuaRes;
    else if (Array.isArray(ketQuaRes?.data)) listKetQua = ketQuaRes.data;
    else if (Array.isArray(ketQuaRes?.data?.data)) listKetQua = ketQuaRes.data.data;
    else if (Array.isArray(ketQuaRes?.data?.$values)) listKetQua = ketQuaRes.data.$values;
    else if (Array.isArray(ketQuaRes?.Data)) listKetQua = ketQuaRes.Data;
    
    const tongDiem = listKetQua.reduce((sum, kq) => sum + ((kq.diemSo !== undefined ? kq.diemSo : kq.DiemSo) || 0), 0);

    const { data: itemAccountAuthInfoRes } = useQuery(
        ['accountAuthInfoLocal', dataHoSo?.accountId], 
        () => Get(ACCOUNT_API.GET_ACCOUNT_BYID_FROM_APP_DUNGCHUNG, dataHoSo?.accountId), 
        { enabled: !!dataHoSo?.accountId && show }
    );
    const { data: itemAccountInfoRes } = useQuery(
        ['accountInfoLocal', dataHoSo?.accountId], 
        () => Get(ACCOUNT_API.GET_ACCOUNT_INFO_BYID_FROM_APP_DUNGCHUNG, dataHoSo?.accountId), 
        { enabled: !!dataHoSo?.accountId && show }
    );

    const itemAccountAuthInfo = itemAccountAuthInfoRes?.data || itemAccountAuthInfoRes || {};
    const itemAccountInfo = itemAccountInfoRes?.data || itemAccountInfoRes || {};

    useEffect(() => {
        if (show && dataHoSo?.accountId) {
            setGhiChuChinhSua(dataHoSo.ghiChuChinhSua || '');
        }
    }, [show, dataHoSo?.accountId]);

    const donViName = itemAccountInfo?.donVis?.length > 0 
        ? itemAccountInfo.donVis.map(d => d.tenDonVi).join(', ') 
        : (itemAccountInfo?.donViNgoaiVien || dataHoSo?.donViNgoaiVien || '');

    const soCCCD = dataHoSo.soCCCD || dataHoSo.SoCCCD || itemAccountAuthInfo?.identityCardNumber || '...';
    const ngayCapCCCD = dataHoSo.ngayCapCCCD || dataHoSo.NgayCapCCCD || itemAccountAuthInfo?.issuanceDateOfIdentityCard;
    const ngayCapCCCDStr = ngayCapCCCD ? moment(ngayCapCCCD).format('DD/MM/YYYY') : '...';
    const noiCapCCCD = dataHoSo.noiCapCCCD || dataHoSo.NoiCapCCCD || itemAccountAuthInfo?.issuancePlaceOfIdentityCard || '...';
    const thuongTruTinhThanh = dataHoSo.thuongTruTinhThanh || dataHoSo.ThuongTruTinhThanh || itemAccountAuthInfo?.hkttAdressProvinceCity || '...';
    const thuongTruXaPhuong = dataHoSo.thuongTruXaPhuong || dataHoSo.ThuongTruXaPhuong || itemAccountAuthInfo?.hkttAdressWardCommune || '...';
    const thuongTruDiaChi = dataHoSo.thuongTruDiaChi || dataHoSo.ThuongTruDiaChi || itemAccountAuthInfo?.address || '...';

    const getLabelFromEnum = (value, objectEnum, valueMap) => {
        if (value === null || value === undefined || value === '') return '';
        let actualValue = value;
        if (typeof value === 'string' && valueMap) {
            // Exact match
            if (valueMap[value] !== undefined) actualValue = valueMap[value];
            else {
                // CamelCase match
                const camelCase = value.charAt(0).toLowerCase() + value.slice(1);
                if (valueMap[camelCase] !== undefined) actualValue = valueMap[camelCase];
                else {
                    // Case-insensitive
                    const matchKey = Object.keys(valueMap).find(k => k.toLowerCase() === value.toLowerCase());
                    if (matchKey) actualValue = valueMap[matchKey];
                }
            }
        }
        const found = objectEnum.find((item) => item.value === actualValue || item.value == value);
        return found ? found.label : (valueMap ? '' : value);
    };

    // Formatters
    const customLoaiCanBoMap = { ...loaiCanBoHuongDanValue, canBoHuongDanChinh: 0, canBoHuongDanPhu: 1, dongHuongDan: 2 };
    const accountGenderName = objectAccountGender.find(x => x.value === itemAccountAuthInfo?.accountGender)?.label;
    const getDoiTuong = (val) => getLabelFromEnum(val, objectObjectAccount, doiTuongValue) || 'Khác';
    const getLoaiVanBang = (val) => getLabelFromEnum(val, objectLoaiVanBang, loaiVanBangValue);
    const getCapQuanLy = (val) => getLabelFromEnum(val, objectCapQuanLy, capQuanLyValue);
    const getLoaiCanBo = (val) => getLabelFromEnum(val, objectLoaiCanBoHuongDan, customLoaiCanBoMap);
    const getNganh = (val) => nganhOptions.find(x => x.value === val)?.label || '';
    const getChuyenNganh = (val) => chuyenNganhOptions.find(x => x.value === val)?.label || '';
    const getTrinhDo = (val) => getLabelFromEnum(val, objectTrinhDoDaoTaoTSTS, trinhDoDaoTaoTSTSValue);
    const getDonViDaoTao = (val) => donViDaoTaoOptions.find(x => x.value === val)?.label || '';
    const getQuocGia = (val) => quocGiaOptions.find(x => x.value === val)?.label || '';
    const getHinhThuc = (val) => hinhThucDaoTaoOptions.find(x => x.value === val)?.label || '';
    const getXepLoai = (val) => xepLoaiDaoTaoOptions.find(x => x.value === val)?.label || '';
    const getTrinhDoId = (val) => trinhDoOptions.find(x => x.value === val)?.label || '';

    const loaiTuyenSinhLabel = getLabelFromEnum(dataHoSo.loaiTuyenSinh ?? dataHoSo.LoaiTuyenSinh ?? loaiTuyenSinhValue.tuyenSinhTienSi, objectLoaiTuyenSinh, loaiTuyenSinhValue);
    const isTuyenSinhTienSi = loaiTuyenSinhLabel === 'Tuyển sinh Tiến sĩ';
    const loaiTuyenSinh = isTuyenSinhTienSi ? 0 : 1;

    const FieldDisplay = ({ label, value }) => (
        <Form.Group className="mb-3">
            <Form.Label className="font-weight-bold text-muted small">{label}</Form.Label>
            <Form.Control type="text" value={value || ''} disabled className="shadow-none bg-white" />
        </Form.Group>
    );

    const FieldDisplayFile = ({ label, value }) => {
        const getSafeUrl = (path) => {
            if (!path) return null;
            if (path.startsWith('http')) return path;
            const baseUrl = BaseGatewayImage.endsWith('/') ? BaseGatewayImage.slice(0, -1) : BaseGatewayImage;
            const safePath = path.startsWith('/') ? path : `/${path}`;
            return `${baseUrl}${safePath}`;
        };

        let files = [];
        if (value) {
            try {
                const parsed = JSON.parse(value);
                if (Array.isArray(parsed)) {
                    files = parsed;
                } else {
                    files = [{ filePath: value, name: value.split('/').pop() }];
                }
            } catch (e) {
                files = [{ filePath: value, name: value.split('/').pop() }];
            }
        }

        return (
            <Form.Group className="mb-3">
                {label && <Form.Label className="font-weight-bold text-muted small d-block">{label}</Form.Label>}
                <div className="d-flex flex-wrap">
                    {files.length > 0 ? (
                        files.map((file, idx) => {
                            const path = file.filePath || file;
                            let name = file.name || (typeof path === 'string' ? path.split('/').pop() : 'File');
                            name = name.replace(/_\d{14}(?=\.\w+$|$)/, '');
                            return (
                                <a key={idx} href={getSafeUrl(path)} target="_blank" rel="noreferrer" className={`btn btn-outline-primary text-left ${label ? '' : 'btn-sm'} mb-1 mr-1`} style={{ maxWidth: '100%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'inline-block' }} title={name}>
                                    <i className="fas fa-paperclip mr-1"></i> {name}
                                </a>
                            );
                        })
                    ) : (
                        <div className={label ? "d-flex align-items-center" : ""} style={label ? { height: '38px' } : {}}>
                            <span className="text-muted small">Không có file đính kèm</span>
                        </div>
                    )}
                </div>
            </Form.Group>
        );
    };

    const handleDuyet = async (actionId) => {
        if (!ghiChuChinhSua && (actionId === 2 || actionId === 4)) {
            toast.warning('Vui lòng nhập ghi chú / lý do để gửi tới người dùng!');
            return;
        }

        setSubmitting(true);
        try {
            const result = await Put(DUYET_HOSO_TUYENSINH_API.DUYET_HO_SO, hoSoId, {
                Action: actionId,
                GhiChuChinhSua: ghiChuChinhSua
            });

            if (result && result.ok) {
                toast.success('Duyệt hồ sơ thành công!');
                setShowConfirmModal(false);
                refetchHoSo();
                handleClose();
            } else {
                toast.error(result?.message || 'Có lỗi xảy ra, vui lòng thử lại.');
            }
        } catch (e) {
            toast.error('Lỗi kết nối máy chủ!');
        } finally {
            setSubmitting(false);
        }
    };

    const isChoDuyet = dataHoSo.trangThaiHoSoDuTuyen === 1;

    return (
        <Modal show={show} onHide={handleClose} size="xl" backdrop="static" style={{ zIndex: 9999 }}>
            <Modal.Header closeButton className="bg-info text-white">
                <Modal.Title><i className="fas fa-eye mr-2"></i> Thông tin hồ sơ tuyển sinh</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ maxHeight: 'calc(100vh - 200px)', overflowY: 'auto' }}>


                {isLoading ? (
                    <div className="text-center py-5">
                        <Spinner animation="border" variant="primary" />
                        <p className="mt-2 text-muted">Đang tải dữ liệu...</p>
                    </div>
                ) : (
                    <Tabs defaultActiveKey="thong-tin-ca-nhan" className="mb-4 custom-tabs">
                        <Tab eventKey="thong-tin-ca-nhan" title={<span><i className="fas fa-user mr-1"></i> Thông tin thí sinh</span>}>
                            <div className="bg-light p-3 rounded border">
                                <Row>
                                    {loaiTuyenSinh === 0 && <Col md={12}><FieldDisplay label="Số hồ sơ" value={dataHoSo.soHoSo || dataHoSo.SoHoSo || 'Chưa cấp'} /></Col>}
                                    <Col md={4}><FieldDisplay label="Họ tên" value={dataHoSo.hoTen} /></Col>
                                    <Col md={4}><FieldDisplay label="Ngày sinh" value={dataHoSo.ngaySinh ? moment(dataHoSo.ngaySinh).format('DD/MM/YYYY') : ''} /></Col>
                                    <Col md={4}><FieldDisplay label="Giới tính" value={accountGenderName} /></Col>
                                    <Col md={4}><FieldDisplay label="Số CCCD" value={soCCCD} /></Col>
                                    <Col md={4}><FieldDisplay label="Ngày cấp CCCD" value={ngayCapCCCDStr} /></Col>
                                    <Col md={4}><FieldDisplay label="Nơi cấp CCCD" value={noiCapCCCD} /></Col>
                                    <Col md={4}><FieldDisplay label="Đối tượng" value={getDoiTuong(dataHoSo.doiTuong)} /></Col>
                                    <Col md={4}><FieldDisplay label="Email" value={dataHoSo.email} /></Col>
                                    <Col md={4}><FieldDisplay label="Số điện thoại" value={dataHoSo.soDienThoai} /></Col>
                                    <Col md={12}><FieldDisplay label="Đơn vị công tác" value={donViName} /></Col>
                                    <Col md={6}><FieldDisplay label="Thường trú (Tỉnh / Thành phố)" value={thuongTruTinhThanh} /></Col>
                                    <Col md={6}><FieldDisplay label="Thường trú (Xã / Phường)" value={thuongTruXaPhuong} /></Col>
                                    <Col md={12}><FieldDisplay label="Thường trú (Địa chỉ chi tiết)" value={thuongTruDiaChi} /></Col>
                                    <Col md={12}><FieldDisplay label="Nơi sinh (Tỉnh / Thành phố)" value={dataHoSo.noiSinh} /></Col>
                                    <Col md={4}><FieldDisplay label="Họ tên người liên hệ" value={dataHoSo.hoTenNguoiLienHe} /></Col>
                                    <Col md={4}><FieldDisplay label="Quan hệ" value={dataHoSo.quanHeNguoiLienHe || dataHoSo.QuanHeNguoiLienHe || ''} /></Col>
                                    <Col md={4}><FieldDisplay label="SĐT người liên hệ" value={dataHoSo.sdtNguoiLienHe} /></Col>
                                </Row>
                            </div>
                        </Tab>

                        <Tab eventKey="thong-tin-du-tuyen" title={<span><i className="fas fa-clipboard-list mr-1"></i> Thông tin đăng ký dự tuyển</span>}>
                            <div className="bg-light p-3 rounded border">
                                {loaiTuyenSinh === 0 ? (
                                    <Row>
                                        <Col md={dataHoSo.chuyenNganhId ? 6 : 12}><FieldDisplay label="Ngành đăng ký" value={getNganh(dataHoSo.nganhId)} /></Col>
                                        {dataHoSo.chuyenNganhId && (
                                            <Col md={6}><FieldDisplay label="Chuyên ngành đăng ký" value={getChuyenNganh(dataHoSo.chuyenNganhId)} /></Col>
                                        )}
                                    </Row>
                                ) : (
                                    <Row>
                                        <Col md={12}><FieldDisplay label="Tên khóa học" value={khoahocData?.tenKhoaHoc || khoahocData?.TenKhoaHoc || khoahocData?.data?.tenKhoaHoc || khoahocData?.data?.TenKhoaHoc || dataHoSo.tenDotTuyenSinh || dataHoSo.TenDotTuyenSinh || ''} /></Col>
                                    </Row>
                                )}
                            </div>
                        </Tab>

                        <Tab eventKey="van-bang" title={<span><i className="fas fa-graduation-cap mr-1"></i> Quá trình đào tạo</span>}>
                            {loaiTuyenSinh === 0 ? (
                                <>
                                    <h5 className="font-weight-bold   mt-3 mb-2" style={{ color: "#1e7e34" }}>Đào tạo đại học (Bác sĩ)</h5>
                                    {vanBangDaiHocs.length > 0 ? (
                                        vanBangDaiHocs.map((vb, idx) => (
                                            <Card key={idx} className="mb-3 shadow-sm border-info">
                                                <Card.Body>
                                                    <Row>
                                                        <Col md={4}><FieldDisplay label="Loại văn bằng" value={getLoaiVanBang(vb.loaiVanBang)} /></Col>
                                                        <Col md={8}><FieldDisplay label="Trường đào tạo" value={
                                                            (getLoaiVanBang(vb.loaiVanBang) === 'Ngoài nước') ? vb.tenTruongNuocNgoai : getDonViDaoTao(vb.donViDaoTaoId)
                                                        } /></Col>
                                                        <Col md={4}><FieldDisplay label="Quốc gia" value={getQuocGia(vb.quocGiaId)} /></Col>
                                                        <Col md={4}><FieldDisplay label="Xếp loại" value={getXepLoai(vb.xepLoaiDaoTaoId)} /></Col>
                                                        <Col md={4}><FieldDisplay label="Năm tốt nghiệp" value={vb.namTotNghiep} /></Col>
                                                        <Col md={12}><FieldDisplay label="Ngành" value={vb.nganhDaoTao} /></Col>
                                                        <Col md={12}><FieldDisplayFile label="File minh chứng văn bằng" value={vb.fileMinhChung} /></Col>
                                                    </Row>
                                                </Card.Body>
                                            </Card>
                                        ))
                                    ) : <div className="alert alert-secondary">Không có dữ liệu đào tạo đại học (Bác sĩ)</div>}

                                    <h5 className="font-weight-bold   mt-4 mb-2" style={{ color: "#1e7e34" }}>Đào tạo sau đại học (Thạc sĩ, BSCKI, BSCKII, Bác sĩ nội trú)</h5>
                                    {vanBangTuyenSinhs.length > 0 ? (
                                        vanBangTuyenSinhs.map((vb, idx) => (
                                            <Card key={idx} className="mb-3 shadow-sm border-info">
                                                <Card.Body>
                                                    <Row>
                                                        <Col md={4}><FieldDisplay label="Loại văn bằng" value={getLoaiVanBang(vb.loaiVanBang)} /></Col>
                                                        <Col md={8}><FieldDisplay label="Trường đào tạo" value={
                                                            (getLoaiVanBang(vb.loaiVanBang) === 'Ngoài nước') ? vb.tenTruongNuocNgoai : getDonViDaoTao(vb.donViDaoTaoId)
                                                        } /></Col>
                                                        <Col md={4}><FieldDisplay label="Trình độ" value={getTrinhDo(vb.trinhDo)} /></Col>
                                                        <Col md={4}><FieldDisplay label="Quốc gia" value={getQuocGia(vb.quocGiaId)} /></Col>
                                                        <Col md={4}><FieldDisplay label="Hình thức đào tạo" value={getHinhThuc(vb.hinhThucDaoTaoId)} /></Col>
                                                        <Col md={4}><FieldDisplay label="Xếp loại" value={getXepLoai(vb.xepLoaiDaoTaoId)} /></Col>
                                                        <Col md={vb.chuyenNganhDaoTao ? 6 : 12}><FieldDisplay label="Ngành" value={vb.nganhDaoTao} /></Col>
                                                        {vb.chuyenNganhDaoTao && (
                                                            <Col md={6}><FieldDisplay label="Chuyên ngành" value={vb.chuyenNganhDaoTao} /></Col>
                                                        )}
                                                        <Col md={4}><FieldDisplay label="Điểm luận văn tốt nghiệp" value={vb.diemLuanVanTN} /></Col>
                                                        <Col md={4}><FieldDisplay label="Điểm trung bình toàn khóa" value={vb.diemTBToanKhoa} /></Col>
                                                        <Col md={4}><FieldDisplay label="Năm tốt nghiệp" value={vb.namTotNghiep} /></Col>
                                                        <Col md={12}><FieldDisplayFile label="File minh chứng văn bằng" value={vb.fileMinhChung} /></Col>
                                                    </Row>
                                                </Card.Body>
                                            </Card>
                                        ))
                                    ) : <div className="alert alert-secondary">Không có dữ liệu đào tạo sau đại học</div>}

                                    <h5 className="font-weight-bold   mt-4 mb-2" style={{ color: "#1e7e34" }}>Văn bằng/Chứng chỉ ngoại ngữ</h5>
                                    {vanBangNgoaiNgus.length > 0 ? (
                                        vanBangNgoaiNgus.map((vb, idx) => (
                                            <Card key={idx} className="mb-3 shadow-sm border-warning">
                                                <Card.Body>
                                                    <Row>
                                                        <Col md={6}><FieldDisplay label="Tên văn bằng/chứng chỉ" value={vb.tenVanBangChungChi} /></Col>
                                                        <Col md={6}><FieldDisplay label="Nơi học" value={vb.noiHoc} /></Col>
                                                        <Col md={4}><FieldDisplay label="Ngày cấp" value={vb.ngayCap ? new Date(vb.ngayCap).toLocaleDateString('vi-VN') : ''} /></Col>
                                                        <Col md={8}><FieldDisplay label="Ghi chú" value={vb.ghiChu} /></Col>
                                                        <Col md={12}><FieldDisplayFile label="File minh chứng ngoại ngữ" value={vb.fileMinhChung} /></Col>
                                                    </Row>
                                                </Card.Body>
                                            </Card>
                                        ))
                                    ) : <div className="alert alert-secondary">Không có dữ liệu văn bằng/chứng chỉ ngoại ngữ</div>}
                                </>
                            ) : (
                                <>
                                    <h5 className="font-weight-bold   mt-3 mb-2" style={{ color: "#1e7e34" }}>Thông tin văn bằng</h5>
                                    {vanBangDaiHocs.length > 0 ? (
                                        vanBangDaiHocs.map((vb, idx) => (
                                            <Card key={idx} className="mb-3 shadow-sm border-info">
                                                <Card.Body>
                                                    <Row>
                                                        <Col md={4}><FieldDisplay label="Loại văn bằng" value={getLoaiVanBang(vb.loaiVanBang ?? vb.LoaiVanBang)} /></Col>
                                                        <Col md={8}><FieldDisplay label="Trường đào tạo" value={
                                                            (getLoaiVanBang(vb.loaiVanBang ?? vb.LoaiVanBang) === 'Ngoài nước') ? (vb.tenTruongNuocNgoai ?? vb.TenTruongNuocNgoai) : getDonViDaoTao(vb.donViDaoTaoId ?? vb.DonViDaoTaoId)
                                                        } /></Col>
                                                        <Col md={4}><FieldDisplay label="Quốc gia" value={getQuocGia(vb.quocGiaId ?? vb.QuocGiaId)} /></Col>
                                                        <Col md={4}><FieldDisplay label="Hệ đào tạo" value={getTrinhDoId(vb.trinhDoId ?? vb.TrinhDoId)} /></Col>
                                                        <Col md={4}><FieldDisplay label="Năm tốt nghiệp" value={vb.namTotNghiep ?? vb.NamTotNghiep} /></Col>
                                                        <Col md={12}><FieldDisplayFile label="File minh chứng" value={vb.fileMinhChung ?? vb.FileMinhChung} /></Col>
                                                    </Row>
                                                </Card.Body>
                                            </Card>
                                        ))
                                    ) : <div className="alert alert-secondary">Không có dữ liệu văn bằng</div>}

                                    <h5 className="font-weight-bold   mt-4 mb-2" style={{ color: "#1e7e34" }}>Các văn bằng khác liên quan đến khóa học</h5>
                                    <Row>
                                        <Col md={12}><FieldDisplayFile label="File văn bằng" value={dataHoSo.fileVanBangKhac ?? dataHoSo.FileVanBangKhac} /></Col>
                                    </Row>
                                </>
                            )}
                        </Tab>

                        {loaiTuyenSinh === 0 && (
                            <Tab eventKey="nghien-cuu" title={<span><i className="fas fa-book mr-1"></i> Nghiên cứu khoa học</span>}>
                            <div className="d-flex justify-content-start align-items-center mt-3 mb-2">
                                <h5 className="font-weight-bold mb-0 mr-4" style={{ color: "#1e7e34" }}>Bài báo khoa học</h5>
                                <h6 className="text-primary font-weight-bold mb-0">Số lượng: <strong className="text-danger">{dataHoSo.soLuongBaiBao || dataHoSo.SoLuongBaiBao || 0}</strong></h6>
                            </div>
                            {baiBaoKhoaHocs.length > 0 ? (
                                <Table striped bordered hover size="sm">
                                    <thead className="bg-light">
                                        <tr>
                                            <th>Tên bài báo</th>
                                            <th>Tạp chí đăng</th>
                                            <th>Năm công bố</th>
                                            <th>Minh chứng</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {baiBaoKhoaHocs.map((bb, idx) => (
                                            <tr key={idx}>
                                                <td>{bb.tenBaiBao}</td>
                                                <td>{bb.tapChiDang}</td>
                                                <td>{bb.namCongBo}</td>
                                                <td><FieldDisplayFile value={bb.fileMinhChung} /></td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            ) : <div className="alert alert-secondary">Không có dữ liệu bài báo khoa học</div>}
                            <div className="mt-2 mb-3">
                                <FieldDisplayFile label="File lý lịch khoa học đính kèm" value={dataLyLich.fileLyLichKhoaHoc} />
                            </div>

                            <div className="d-flex justify-content-start align-items-center mt-4 mb-2">
                                <h5 className="font-weight-bold mb-0 mr-4" style={{ color: "#1e7e34" }}>Đề tài nghiên cứu khoa học</h5>
                                <h6 className="text-primary font-weight-bold mb-0">Số lượng: <strong className="text-danger">{dataHoSo.soLuongDeTaiKhoaHoc || dataHoSo.SoLuongDeTaiKhoaHoc || 0}</strong></h6>
                            </div>
                            {deTaiNCKHs.length > 0 ? (
                                <Table striped bordered hover size="sm">
                                    <thead className="bg-light">
                                        <tr>
                                            <th>Tên đề tài</th>
                                            <th>Cấp quản lý</th>
                                            <th>Năm nghiệm thu</th>
                                            <th>Minh chứng</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {deTaiNCKHs.map((dt, idx) => (
                                            <tr key={idx}>
                                                <td>{dt.tenDeTaiNCKH}</td>
                                                <td>{getCapQuanLy(dt.capQuanLy)}</td>
                                                <td>{dt.namNghiemThu}</td>
                                                <td><FieldDisplayFile value={dt.fileMinhChung} /></td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            ) : <div className="alert alert-secondary">Không có dữ liệu đề tài NCKH</div>}


                            </Tab>
                        )}

                        {loaiTuyenSinh === 0 && (
                            <Tab eventKey="de-cuong-du-tuyen" title={<span><i className="fas fa-file-signature mr-1"></i> Đề cương dự tuyển</span>}>
                            <div className="bg-light p-3 rounded border mt-3">
                                <h5 className="font-weight-bold mb-3 border-bottom pb-2" style={{ color: "#1e7e34" }}>
                                    <i className="fas fa-file-signature mr-2"></i> Đề cương nghiên cứu & Cán bộ hướng dẫn
                                </h5>
                                <Row>
                                    <Col md={12}><FieldDisplay label="Tên đề cương" value={dataDeCuong.tenDeCuong || ''} /></Col>
                                </Row>
                                <div className="mt-2 mb-3">
                                    <FieldDisplayFile label="File đề cương nghiên cứu đính kèm" value={dataDeCuong.fileMinhChung} />
                                </div>
                                {canBoHuongDans.length > 0 ? (
                                    <Table striped bordered hover size="sm" responsive>
                                        <thead className="bg-white">
                                            <tr>
                                                <th style={{ whiteSpace: 'nowrap' }}>Họ tên</th>
                                                <th style={{ whiteSpace: 'nowrap' }}>Vai trò cán bộ</th>
                                                <th style={{ whiteSpace: 'nowrap' }}>Đơn vị công tác</th>
                                                <th style={{ width: '25%' }}>Lý lịch khoa học</th>
                                                <th style={{ width: '25%' }}>Minh chứng</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {canBoHuongDans.map((cb, idx) => (
                                                <tr key={idx}>
                                                    <td className="align-middle" style={{ whiteSpace: 'nowrap' }}>{cb.hoTen}</td>
                                                    <td className="align-middle" style={{ whiteSpace: 'nowrap' }}>{getLoaiCanBo(cb.loaiCanBoHuongDan)}</td>
                                                    <td className="align-middle" style={{ whiteSpace: 'nowrap' }}>{cb.donViCongTac}</td>
                                                    <td className="align-middle"><FieldDisplayFile value={cb.fileLyLichKhoaHoc} /></td>
                                                    <td className="align-middle"><FieldDisplayFile value={cb.fileMinhChungCanBo} /></td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                ) : <p className="text-muted small">Không có cán bộ hướng dẫn</p>}
                            </div>
                            </Tab>
                        )}

                        <Tab eventKey="ho-so-dinh-kem" title={<span><i className="fas fa-paperclip mr-1"></i> Hồ sơ đính kèm</span>}>
                            <div className="bg-light p-3 rounded border mt-3">
                                {loaiTuyenSinh === 0 ? (
                                    <Row>
                                        <Col md={6}><FieldDisplayFile label="1. Đơn đăng ký dự tuyển" value={dataHoSo.fileDonXinDuTuyen} /></Col>
                                        <Col md={6}><FieldDisplayFile label="2. Công văn/Quyết định cử đi dự tuyển của cơ quan chủ quản (không áp dụng với thí sinh quân đội, thí sinh tự do)" value={dataHoSo.fileCongVanCuDi} /></Col>
                                        <Col md={6}><FieldDisplayFile label="3. Sơ yếu lý lịch" value={dataHoSo.fileSoYeuLyLich} /></Col>
                                        <Col md={6}><FieldDisplayFile label="4. Giấy khám sức khỏe" value={dataHoSo.fileGiayKhamSucKhoe} /></Col>
                                        <Col md={6}><FieldDisplayFile label="5. Thư giới thiệu của giáo sư/phó giáo sư (chỉ áp dụng với thí sinh tự do)" value={dataHoSo.fileGiayChapThuan} /></Col>
                                        <Col md={6}><FieldDisplayFile label="6. Ảnh chân dung 3x4 cm chụp trong vòng 1 năm trở lại đây" value={dataHoSo.fileAnhChanDung} /></Col>
                                        <Col md={6}><FieldDisplayFile label="7. Minh chứng đóng lệ phí" value={dataHoSo.fileMinhChungLePhi} /></Col>
                                    </Row>
                                ) : (
                                    <Row>
                                        <Col md={6}><FieldDisplayFile label="1. Đơn đăng ký học" value={dataHoSo.fileDonXinDuTuyen} /></Col>
                                        <Col md={6}><FieldDisplayFile label="2. Bằng tốt nghiệp (công chứng)" value={dataHoSo.fileBangTotNghiep} /></Col>
                                        <Col md={6}><FieldDisplayFile label="3. Sơ yếu lý lịch (có dấu xác nhận của địa phương)" value={dataHoSo.fileSoYeuLyLich} /></Col>
                                        <Col md={6}><FieldDisplayFile label="4. Ảnh chân dung 3x4 và 4x6 (02 ảnh)" value={dataHoSo.fileAnhChanDung} /></Col>
                                        <Col md={6}><FieldDisplayFile label="5. Căn cước công dân photo" value={dataHoSo.fileAnhCccd} /></Col>
                                        <Col md={6}><FieldDisplayFile label="6. Minh chứng đóng lệ phí" value={dataHoSo.fileMinhChungLePhi} /></Col>
                                    </Row>
                                )}
                            </div>
                        </Tab>
                        {loaiTuyenSinh === 0 && (
                            <Tab eventKey="danh-gia-ho-so" title={<span><i className="fas fa-check-square mr-1"></i> Đánh giá hồ sơ</span>}>
                            <div className="bg-light p-3 rounded border mt-3">
                                <DanhGiaHoSoTuyenSinhTienSiForm hoSoId={hoSoId} readOnly={false} />
                            </div>
                            </Tab>
                        )}
                        
                        {loaiTuyenSinh === 0 && (dataDeCuong?.id || dataDeCuong?.Id) && (
                            <Tab eventKey="ket-qua-danh-gia" title={<span><i className="fas fa-star text-warning mr-1"></i> Kết quả đánh giá thí sinh</span>}>
                                <div className="bg-light p-3 rounded border mt-3">
                                    <DanhGiaThiSinhForm hoSoId={hoSoId} dataDeCuong={dataDeCuong} readOnly={true} />
                                </div>
                            </Tab>
                        )}
                        
                        <Tab eventKey="ket-qua-tuyen-sinh" title={<span><i className="fas fa-award  mr-1"></i> Kết quả tuyển sinh</span>}>
                            <KetQuaTuyenSinhTab hoSoId={hoSoId} deCuongId={dataDeCuong?.id || dataDeCuong?.Id} loaiTuyenSinh={loaiTuyenSinh} />
                        </Tab>
                    </Tabs>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Đóng
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default DuyetHoSoTuyenSinhDetailModal;
